import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({
  params: {
    page: 1,
    limit: 15,
  },
});

export const QuestoesChecklistSlice = createSlice({
  name: "questoesChecklist",
  initialState,
  reducers: {
    handleParams: (state, { payload }) => {
      const field = payload?.field;
      if (payload?.isDelete) {
        delete state.params[field];
      } else {
        state.params[field] = payload?.value;
      }
      return state;
    },
    handleClearParams: (state, { payload }) => {
      delete state.params[payload?.field];
      return state;
    },
  },
});

export const { handleParams, handleClearParams } = QuestoesChecklistSlice.actions;
export default QuestoesChecklistSlice.reducer;
